import { render, staticRenderFns } from "./roof-search.vue?vue&type=template&id=aa1d5cd4&scoped=true&"
import script from "./roof-search.vue?vue&type=script&lang=js&"
export * from "./roof-search.vue?vue&type=script&lang=js&"
import style0 from "./roof-search.vue?vue&type=style&index=0&id=aa1d5cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1d5cd4",
  null
  
)

export default component.exports